import { ISearchPage, IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

export interface IWebSiteDetails {
    "id"?: string,
    "code"?: string,   // "站点域名",
    "name"?: string,   // "站点名称",
    "isPwd"?: string | number,   // "是否免密登录",
    "userName"?: string,   // "用户名称",
    "userPwd"?: string,   // "用户密码",
    "icon"?: string,   // "站点图标",
    "note"?: string,   // "备注",
    "orderNum"?: string,   // "顺位",
}

export interface IWebSiteSeachFields {

}

export interface IWebSiteSearch extends
    IWebSiteSeachFields, ISearchPage {

}

class WebSiteService {
    //列表
    async page(searchVo: IWebSiteSearch) {
        const apiUrl = "/website/page";
        return await httpRequest.post<IPage<IWebSiteDetails>>(apiUrl, searchVo);
    }
    async insert(obj: IWebSiteDetails) {
        const apiUrl = "/website/insert";
        return await httpRequest.post<boolean>(apiUrl, obj);
    }
    async update(obj: IWebSiteDetails) {
        const apiUrl = "/website/update";
        return await httpRequest.post<boolean>(apiUrl, obj);
    }
    async remove(id: string) {
        const apiUrl = `/website/remove/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
}
export const webSiteService = new WebSiteService();